<template>
    <el-dialog
            class="scheduler-dialog"
            fullscreen
            :visible.sync="dialogVisible"
            v-if="dialogVisible"
            :before-close="handleClose">
        <div class="container">
          <scheduler 
            class="left-container"
            ref="schedulerREF"
            :events="events"></scheduler>
        </div>
        <!-- :title="$t('project_schedulerModal_title')" -->
    </el-dialog>
</template>

<script>
  import axios from 'axios'
  import Scheduler from './Scheduler.vue';
  import moment from 'moment'
  export default {
    name: "SchedulerModal",
    components: {
      Scheduler
    },
    props: ['selectedUserId'],
    data(){
      return{
        moment:moment,
        dialogVisible: false,
        events: [
          // { id:1, start_date:"2021-01-24 6:00", end_date: "2021-01-24 6:00", text:"Event 1"},
          // { id:2, start_date:"2021-01-25 6:00", end_date: "2021-01-25 6:00", text:"Event 2"}
        ]
      }
    },
    methods:{
      openModal() {
        // this.dialogVisible = true
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/calendar/user?companyId=${this.$route.query.companyId}&userId=${this.selectedUserId}`)
          .then(response => {
            console.log('response', response.data)

            let arr = response.data.list
            for (let i = 0; i < arr.length; i++) {
              arr[i].start_date = moment(arr[i].start_date * 1000).format('YYYY-MM-DD HH:mm').toString()
              arr[i].end_date = moment(arr[i].end_date * 1000).format('YYYY-MM-DD HH:mm').toString()
            }

            this.events = arr
            this.dialogVisible = true
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      handleClose(){
        this.$refs.schedulerREF.closeScheduler();
        this.dialogVisible = false
      }
    }
  }
</script>

<style lang="less" scoped>
    .scheduler-dialog{
        /deep/.el-dialog__body{
            height: 90%;
        }
    }
    .container {
      height: 100%;
      width: 100%;
    }
  
    .left-container {
      overflow: hidden;
      position: relative;
      height: 100%
    }
</style>
